const PostSubmission = () => {
  return (
    <section
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 20,
        justifyContent: "center",
        alignItems: "center",
        height: "80vh",
      }}
    >
      <div>
        Success! You will receive an email with further instructions when
        match(s) are found.
      </div>
      <div>
        In the meantime:
        <ul>
          <li>
            I would{" "}
            <a href="https://twitter.com/paulg/status/898476047263518720">
              love
            </a>{" "}
            to hear any feedback:{" "}
            <a href="mailto:adamzerner@protonmail.com">
              adamzerner@protonmail.com
            </a>
            .
          </li>
          <li>
            If you have any friends who you think would be interested in this
            app, it would be awesome if you shared it with them.
          </li>
          <li>
            If you woud like to buy me a coffee, you can do so{" "}
            <a href="https://www.buymeacoffee.com/adamzerner">here</a>.
          </li>
        </ul>
      </div>
    </section>
  );
};

export default PostSubmission;
